import { render, staticRenderFns } from "./QueueDetailDate.vue?vue&type=template&id=60a7d268&scoped=true&"
import script from "./QueueDetailDate.vue?vue&type=script&lang=js&"
export * from "./QueueDetailDate.vue?vue&type=script&lang=js&"
import style0 from "./QueueDetailDate.vue?vue&type=style&index=0&id=60a7d268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7d268",
  null
  
)

export default component.exports